import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { get, indexOf } from 'lodash';

import { UserAuth } from './user.auth';

@Injectable({
  providedIn: 'root'
})
export class UserAuthInterceptor implements HttpInterceptor {
  whitelistedRoutes: Array<string> = ['logo.clearbit.com'];
  whitelistedAPI: Array<string> = ['/sbi/restconf/data/ietf-lmap-control:lmap'];

  constructor(private readonly userAuth: UserAuth) {}
  //eslint-disable-next-line
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isWhiteListed(request) || this.iswhitelistedAPI(request)) {
      return next.handle(request).pipe(
        tap(
          (event: HttpEvent<any>) => {}, //eslint-disable-line
          (err: any) => {} //eslint-disable-line
        )
      );
    }
    // intercepting logged-in (private) http requests beside whitelistedApi calls, if exists:
    // [&& request.url doesn't match one of whitelisted routes]
    const currentUser = sessionStorage.getItem(this.userAuth.STORAGE_KEY);
    if (currentUser) {
      const currentUserJson = JSON.parse(currentUser);
      const application_name = sessionStorage.getItem(this.userAuth.APPLICATION);
      const fusionLogout = request.url === '/ims/v1/logout' && application_name === 'fusion';
      request = request.clone({
        setHeaders: {
          Authorization: `${
            fusionLogout ? currentUserJson.token : 'Bearer ' + currentUserJson.token
          }`
        }
      });
      return next.handle(request);
    }

    // intercepting public http requests
    else {
      return next.handle(request).pipe(
        tap(
          (event: HttpEvent<any>) => {}, // eslint-disable-line
          (err: any) => {} // eslint-disable-line
        )
      );
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  isWhiteListed(request: HttpRequest<any>) {
    const testDomain = this._getDomainFromUrl(request.url);
    const index = indexOf(this.whitelistedRoutes, testDomain);
    return index > -1;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  iswhitelistedAPI(request: HttpRequest<any>) {
    const index = indexOf(this.whitelistedAPI, request.url);
    return index > -1;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  _getDomainFromUrl(serviceUrl): string {
    if (serviceUrl && serviceUrl.match) {
      //eslint-disable-next-line
      const match = serviceUrl.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/im);
      return get(match, '[1]', 'null');
    }
    return 'null';
  }
}
